"use strict";
/*
 * Created on 20.11.2018
 */

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var immutable_1 = require("immutable");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var BigNumberGreaterThanValidator_1 = require("../../core/model/data-dictionary/validators/BigNumberGreaterThanValidator");

var BigNumberRangeValidator_1 = require("../../core/model/data-dictionary/validators/BigNumberRangeValidator");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var FlagSet_1 = require("../../core/model/FlagSet");

var PriceFormulas_1 = require("../../core/model/math/PriceFormulas");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");

var utils_1 = require("../../core/utils");

var CostPriceFormatEnum_1 = require("./CostPriceFormatEnum");

var SupplierAgreementWarningFlag_1 = require("./SupplierAgreementWarningFlag");

var UnitBackDiscountRealizationEnum_1 = require("./UnitBackDiscountRealizationEnum");
/**
 * This class extends supplier about information useful in promotion.
 * @author ZSr
 * @author Stepan Mik
 */


var SupplierAgreement =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(SupplierAgreement, _StateDomainObject_1$);

  /**
   * Ctor.
   *
   * <br/>
   *
   * <b>The supplier currency mentioned below should corresponds with set value of {@link this.currencyId currency id}.</b>
   *
   * TODO add identification references to window and product
   * TODO it is not a good idea to model attributes related to prices as single value
   *     (it cannot encapsulate information about vat, price with/without vat, rounded price etc.)
   *
   * @param id Internal (our) id of entity.
   * @param externalId External id of entity, e.g. used within exports.
   * @param supplierId Supplier identification.
   * @param currencyId Identification of currency used for prices (see below). Should be set to supplier's currency at time of
   *        agreement creation.
   * @param windowItemId - bindings to windowItem
   * @param promotionId - binding to promotion
   * @param preferred - if true supplier is preferred for given product/GoS combination
   * @param regularPurchasePrice Supplier purchase price in supplier currency. Value represents gross price. The source of the value
   *        should be the purchase price lists.
   * @param promoPurchasePrice Promotional purchase price entered by user in supplier currency.
   * @param promoPurchasePricePlus Supplier purchase price with additional costs such as transport cost. Computed as
   *        gross - nett price + promoPurchasePrice (in supplier currency).
   *        i.e. promoPurchasePricePlus = promoPurchasePrice + ({@link this.regularPurchasePrice} - {@link this.regularPurchasePriceNett})
   * @param regularPurchasePriceNett Supplier purchase price after discount. This value is serves mainly for KPI, cannot be used in UI.
   *        Value is in supplier currency. The value has also impact on computation of promoPurchasePricePlus. The source of the value
   *        should be the purchase price lists.
   * @param promoPurchaseStartDate The value should represent the first day a company starts to buy assortment for promotion using
   *        promotional purchase prices. Default value should be set as start date of window - 16 days, but use can change this value. The
   *        value is important within recalculation of purchase prices within nightly calculation (items which this value in the past
   *        should be recalculated. Value has also impact on currencies conversions, which should be performed to this date.
   * @param promoPurchaseEndDate Relates to {@link this.promoPurchaseStartDate} representing the end of validity. Default should probably
   *        be set to the start of window validity.
   * @param purchaseForecastSMPA
   * @param confirmedPurchaseForecastSMPA - copy of purchaseForecastSMPA can be changed
   * @param obligatoryToBuy - if true confirmedPurchaseForecastSMPA has to be buy
   * @param split - calculated ratio defining a percentage (value of interval <0,1>) of supplier's promo volume
   * @param promoVolume - pre-filled, a portion of system volume
   * (got from promo optimization api) based on split ratio, can be changed via split value
   * @param minimalVolume
   * @param maximalVolume
   * @param unitBackDiscount - user input, back discount on product in supplier currency
   * @param supplierInvoice
   * @param unitBackDiscountRealization - enum value
   * @param secondaryPlacementFee
   * @param leafletFee
   * @param stateFlags
   * @param warningFlags
   * @param costPriceFormat - LOG-6647
   * @param processed defines whether an instance was processed (used primarily for import)
   * @param snapshotOriginId | null
   * @param lastPromoPurchaseUpdate time of the last change of promo purchase price or period
   */
  function SupplierAgreement(id, externalId, supplierId, currencyId, windowItemId, promotionId, preferred, regularPurchasePrice, // shouldn't be null
  promoPurchasePrice, // shouldn't be null
  promoPurchasePricePlus, // shouldn't be null
  regularPurchasePriceNett, // shouldn't be null
  promoPurchaseStartDate, promoPurchaseEndDate, purchaseForecastSMPA, confirmedPurchaseForecastSMPA, obligatoryToBuy, split, //TODO Why is promoVolume here? Promo volume is attribute of WindowItem! SA promo volume = WI.promoVolume * split
  promoVolume, minimalVolume, maximalVolume, unitBackDiscount, // shouldn't be null
  supplierInvoice, unitBackDiscountRealization, secondaryPlacementFee, leafletFee, stateFlags, warningFlags, costPriceFormat, processed) {
    var _this;

    var snapshotOriginId = arguments.length > 29 && arguments[29] !== undefined ? arguments[29] : null;
    var lastPromoPurchaseUpdate = arguments.length > 30 && arguments[30] !== undefined ? arguments[30] : null;

    _classCallCheck(this, SupplierAgreement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreement).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.supplierId = supplierId;
    _this.currencyId = currencyId;
    _this.windowItemId = windowItemId;
    _this.promotionId = promotionId;
    _this.preferred = preferred;
    _this.regularPurchasePrice = regularPurchasePrice;
    _this.promoPurchasePrice = promoPurchasePrice;
    _this.promoPurchasePricePlus = promoPurchasePricePlus;
    _this.regularPurchasePriceNett = regularPurchasePriceNett;
    _this.promoPurchaseStartDate = promoPurchaseStartDate;
    _this.promoPurchaseEndDate = promoPurchaseEndDate;
    _this.purchaseForecastSMPA = purchaseForecastSMPA;
    _this.confirmedPurchaseForecastSMPA = confirmedPurchaseForecastSMPA;
    _this.obligatoryToBuy = obligatoryToBuy;
    _this.split = split;
    _this.promoVolume = promoVolume;
    _this.minimalVolume = minimalVolume;
    _this.maximalVolume = maximalVolume;
    _this.unitBackDiscount = unitBackDiscount;
    _this.supplierInvoice = supplierInvoice;
    _this.unitBackDiscountRealization = unitBackDiscountRealization;
    _this.secondaryPlacementFee = secondaryPlacementFee;
    _this.leafletFee = leafletFee;
    _this.stateFlags = stateFlags;
    _this.warningFlags = warningFlags;
    _this.costPriceFormat = costPriceFormat;
    _this.processed = processed;
    _this.snapshotOriginId = snapshotOriginId;
    _this.lastPromoPurchaseUpdate = lastPromoPurchaseUpdate;
    return _this;
  }

  _createClass(SupplierAgreement, [{
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "isCanceled",
    value: function isCanceled(promotion, window, windowItem) {
      return windowItem.isCanceled(promotion, window);
    }
  }, {
    key: "applyDTO",
    value: function applyDTO(dto) {
      return new SupplierAgreement(this.id, this.externalId, this.supplierId, this.currencyId, this.windowItemId, this.promotionId, this.applyIfDefinedInDTO(this.preferred, dto.preferred), this.regularPurchasePrice, this.applyIfDefinedInDTO(this.promoPurchasePrice, dto.promoPurchasePrice), this.applyIfDefinedInDTO(this.promoPurchasePricePlus, dto.promoPurchasePricePlus), this.regularPurchasePriceNett, this.applyIfDefinedInDTO(this.promoPurchaseStartDate, dto.promoPurchaseStartDate), this.applyIfDefinedInDTO(this.promoPurchaseEndDate, dto.promoPurchaseEndDate), this.applyIfDefinedInDTO(this.purchaseForecastSMPA, dto.purchaseForecastSMPA), this.applyIfDefinedInDTO(this.confirmedPurchaseForecastSMPA, dto.confirmedPurchaseForecastSMPA), this.applyIfDefinedInDTO(this.obligatoryToBuy, dto.obligatoryToBuy), this.applyIfDefinedInDTO(this.split, dto.split), this.applyIfDefinedInDTO(this.promoVolume, dto.promoVolume), this.applyIfDefinedInDTO(this.minimalVolume, dto.minimalVolume), this.applyIfDefinedInDTO(this.maximalVolume, dto.maximalVolume), this.applyIfDefinedInDTO(this.unitBackDiscount, dto.unitBackDiscount), this.applyIfDefinedInDTO(this.supplierInvoice, dto.supplierInvoice), this.applyIfDefinedInDTO(this.unitBackDiscountRealization, dto.unitBackDiscountRealization), this.applyIfDefinedInDTO(this.secondaryPlacementFee, dto.secondaryPlacementFee), this.applyIfDefinedInDTO(this.leafletFee, dto.leafletFee), this.stateFlags, this.applyIfDefinedInDTO(this.warningFlags, dto.warningFlags), this.applyIfDefinedInDTO(this.costPriceFormat, dto.costPriceFormat), this.processed, this.snapshotOriginId, this.applyIfDefinedInDTO(this.lastPromoPurchaseUpdate, dto.lastPromoPurchaseUpdate));
    }
  }, {
    key: "applyIfDefinedInDTO",
    value: function applyIfDefinedInDTO(orig, dto) {
      return dto !== undefined ? dto : orig;
    }
  }, {
    key: "withAppliedSimulation",
    value: function withAppliedSimulation(simulation) {
      var _a;

      if (simulation.originId === null) {
        throw new Error("Unset originId when applying simulation values ".concat(JSON.stringify(simulation), " to supplier agreement ").concat(this.id));
      }

      var simPrice = (_a = simulation.promoPurchasePrice) === null || _a === void 0 ? void 0 : _a.simulatedValue;

      var _ref = utils_1.Utils.isValueMissing(simPrice) ? [this.promoPurchasePrice, this.promoPurchasePricePlus] : [simPrice, PriceFormulas_1.PriceFormulas.computePromoPurchasePricePlus(this.regularPurchasePrice || big_decimal_1.BigDecimal.ZERO, this.regularPurchasePriceNett || big_decimal_1.BigDecimal.ZERO, simPrice)],
          _ref2 = _slicedToArray(_ref, 2),
          ppp = _ref2[0],
          pppp = _ref2[1];

      return this.copyMulti({
        promoPurchasePrice: ppp,
        promoPurchasePricePlus: pppp,
        unitBackDiscount: simulation.unitBackDiscount !== null ? simulation.unitBackDiscount.simulatedValue : this.unitBackDiscount,
        promoVolume: simulation.promoVolume !== null ? simulation.promoVolume.simulatedValue : this.promoVolume
      });
    }
  }, {
    key: "withPurchaseAttributes",
    value: function withPurchaseAttributes(attrs) {
      var agg = this;
      agg = agg.copyMulti({
        regularPurchasePrice: attrs.regularPurchasePrice,
        promoPurchasePrice: attrs.promoPurchasePrice,
        promoPurchasePricePlus: attrs.promoPurchasePricePlus,
        regularPurchasePriceNett: attrs.regularPurchasePriceNett,
        promoPurchaseStartDate: attrs.promoPurchaseStartDate,
        promoPurchaseEndDate: attrs.promoPurchaseEndDate,
        costPriceFormat: attrs.costPriceFormat,
        lastPromoPurchaseUpdate: attrs.lastPromoPurchaseUpdate
      });
      return agg;
    }
  }, {
    key: "withDefaultPurchaseAttributes",
    value: function withDefaultPurchaseAttributes(windowStartDate, windowEndDate) {
      if (this.lastPromoPurchaseUpdate === null) {
        // Defaults should not be filled if promo purchase price is missing
        return this;
      }

      var agg = this;
      agg = agg.copyMulti({
        promoPurchaseStartDate: agg.promoPurchaseStartDate === null ? SupplierAgreement.defaultPromoPurchaseStartDate(windowStartDate) : agg.promoPurchaseStartDate,
        promoPurchaseEndDate: agg.promoPurchaseEndDate === null ? windowEndDate.clone().endOf('day') : agg.promoPurchaseEndDate,
        costPriceFormat: agg.costPriceFormat === null ? SupplierAgreement.DEFAULT_COST_PRICE_FORMAT : agg.costPriceFormat
      });
      return agg;
    }
    /**
     * LOG-7688: Initializes attributes with only regular purchase price.
     * @param regularPurchasePrice
     * @param regularPurchasePriceNett
     */

  }], [{
    key: "empty",
    value: function empty() {
      return new SupplierAgreement(utils_1.Utils.VOID_ID, utils_1.Utils.VOID_ID, utils_1.Utils.VOID_ID, utils_1.Utils.VOID_ID, utils_1.Utils.VOID_ID, utils_1.Utils.VOID_ID, false, null, null, null, null, null, null, null, null, false, big_decimal_1.bigdecimal(1), big_decimal_1.bigdecimal(0), null, null, null, null, null, null, null, new FlagSet_1.FlagSet(EntityStateFlag_1.EntityStateFlag), new FlagSet_1.FlagSet(SupplierAgreementWarningFlag_1.SupplierAgreementWarningFlag), null, false, null, null);
    }
    /**
     * Computes weighted average of values derived from supplier agreement, agreement split is used as
     * weight during averaging.
     * @param agreements collection of agreements to be averaged
     * @param attribute function that derives value from supplier agreement instance (usually value of agreement attribute)
     * @returns weighted average or zero if sum of splits of provided agreements
     * is zero (this also covers the case when input collection is empty).
     */

  }, {
    key: "weightedAverage",
    value: function weightedAverage(agreements, attribute) {
      var ret = SupplierAgreement.weightedAverageOpt(agreements, attribute);
      return ret ? ret : big_decimal_1.BigDecimal.ZERO;
    }
  }, {
    key: "weightedAverageOpt",
    value: function weightedAverageOpt(agreements, attribute) {
      var splitSum = big_decimal_1.BigDecimal.ZERO;
      var sum = big_decimal_1.BigDecimal.ZERO;
      var hasValue = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = agreements.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var ag = _step.value;
          var attr = attribute(ag);

          if (attr) {
            hasValue = true;
            splitSum = splitSum.add(ag.split);
            sum = sum.add(attr.mul(ag.split));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!hasValue) {
        return null;
      }

      return splitSum.gt(0) ? sum.div(splitSum) : big_decimal_1.BigDecimal.ZERO;
    }
  }, {
    key: "getFeeSums",
    value: function getFeeSums(supplierAgreements) {
      var ret = [big_decimal_1.BigDecimal.ZERO, big_decimal_1.BigDecimal.ZERO];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = supplierAgreements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var sa = _step2.value;
          ret = [ret[0].add(sa.secondaryPlacementFee ? sa.secondaryPlacementFee : PriceFormulas_1.PriceFormulas.ZERO), ret[1].add(sa.leafletFee ? sa.leafletFee : PriceFormulas_1.PriceFormulas.ZERO)];
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return ret;
    }
    /**
     * Returns fee sums grouped by windowItemId.
     * @param supplierAgreements
     */

  }, {
    key: "getFeeSumsGroupedByWindowItemId",
    value: function getFeeSumsGroupedByWindowItemId(supplierAgreements) {
      return supplierAgreements.groupBy(function (sa) {
        return sa.windowItemId;
      }).map(function (l) {
        return SupplierAgreement.getFeeSums(l.toList());
      }).toMap();
    }
    /**
     * Converter from data-dictionary representation
     */

  }, {
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SupplierAgreement(mat.id, mat.externalId, mat.supplierId, mat.currencyId, mat.windowItemId, mat.promotionId, mat.preferred, mat.regularPurchasePrice, mat.promoPurchasePrice, mat.promoPurchasePricePlus, mat.regularPurchasePriceNett, mat.promoPurchaseStartDate, mat.promoPurchaseEndDate, mat.purchaseForecastSMPA, mat.confirmedPurchaseForecastSMPA, mat.obligatoryToBuy, mat.split, mat.promoVolume, mat.minimalVolume, mat.maximalVolume, mat.unitBackDiscount, mat.supplierInvoice, mat.unitBackDiscountRealization, mat.secondaryPlacementFee, mat.leafletFee, mat.stateFlags, mat.warningFlags, mat.costPriceFormat, mat.processed, mat.snapshotOriginId, mat.lastPromoPurchaseUpdate);
    }
    /** returns default promoPurchase  */

  }, {
    key: "defaultPromoPurchaseStartDate",
    value: function defaultPromoPurchaseStartDate(windowDateFrom) {
      return windowDateFrom.clone().subtract(16, 'days');
    }
  }, {
    key: "computePromoPurchasePricePlus",
    value: function computePromoPurchasePricePlus(regPurchasePrice, regPurchasePriceNett, promoPurchasePrice) {
      return regPurchasePrice.minus(regPurchasePriceNett).plus(promoPurchasePrice);
    }
  }, {
    key: "initPromoWithRegularPurchasePrice",
    value: function initPromoWithRegularPurchasePrice(regularPurchasePrice, regularPurchasePriceNett) {
      var promoPurchasePrice = regularPurchasePrice.round(2); // according to RFC 360

      return {
        regularPurchasePrice: regularPurchasePrice,
        promoPurchasePrice: promoPurchasePrice,
        promoPurchasePricePlus: PriceFormulas_1.PriceFormulas.computePromoPurchasePricePlus(regularPurchasePrice, regularPurchasePriceNett, promoPurchasePrice),
        regularPurchasePriceNett: regularPurchasePriceNett,
        promoPurchaseStartDate: null,
        promoPurchaseEndDate: null,
        costPriceFormat: null,
        lastPromoPurchaseUpdate: null
      };
    }
    /**
     * LOG-7688: Determines copied purchase attributes based on lastPromoPurchaseUpdate flag.
     * lastPromoPurchaseUpdate is set to some date only if Promotion purchase price was explicitly specified.
     * @param regularPurchasePrice
     * @param regularPurchasePriceNett
     */

  }, {
    key: "copyPurchasePrices",
    value: function copyPurchasePrices(regularPurchasePrice, regularPurchasePriceNett, promoPurchasePrice, promoPurchaseStartDate, promoPurchaseEndDate, costPriceFormat, lastPromoPurchaseUpdate) {
      if (!lastPromoPurchaseUpdate || !promoPurchasePrice) {
        return SupplierAgreement.initPromoWithRegularPurchasePrice(regularPurchasePrice, regularPurchasePriceNett);
      }

      return {
        regularPurchasePrice: regularPurchasePrice,
        promoPurchasePrice: promoPurchasePrice,
        promoPurchasePricePlus: PriceFormulas_1.PriceFormulas.computePromoPurchasePricePlus(regularPurchasePrice, regularPurchasePriceNett, promoPurchasePrice),
        regularPurchasePriceNett: regularPurchasePriceNett,
        promoPurchaseStartDate: promoPurchaseStartDate,
        promoPurchaseEndDate: promoPurchaseEndDate,
        costPriceFormat: costPriceFormat || SupplierAgreement.DEFAULT_COST_PRICE_FORMAT,
        lastPromoPurchaseUpdate: lastPromoPurchaseUpdate
      };
    }
  }]);

  return SupplierAgreement;
}(StateDomainObject_1.StateDomainObject);

exports.SupplierAgreement = SupplierAgreement;
SupplierAgreement.DOCUMENT_TYPE = 'SupplierAgreement';
SupplierAgreement.EMPTY_LIST = immutable_1.List();
SupplierAgreement.DEFAULT_COST_PRICE_FORMAT = CostPriceFormatEnum_1.CostPriceFormatEnum.format90000;
/**
 * Minimal correct value of split value.
 */

SupplierAgreement.SPLIT_VALUE_MIN = 0;
SupplierAgreement.SPLIT_VALUE_MAX = 1;
SupplierAgreement.SPLIT_VALUE_MIN_PERCENTAGE = 0;
SupplierAgreement.SPLIT_VALUE_MAX_PERCENTAGE = 100;

SupplierAgreement.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SupplierAgreement.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    supplierId: builder.str('supplierId'),
    currencyId: builder.str('currencyId'),
    windowItemId: builder.str('windowItemId'),
    promotionId: builder.str('promotionId'),
    preferred: builder.bool('preferred'),
    regularPurchasePrice: builder.opt(builder.bigNum('regularPurchasePrice')),
    promoPurchasePrice: builder.opt(builder.bigNum('promoPurchasePrice')),
    promoPurchasePricePlus: builder.opt(builder.bigNum('promoPurchasePricePlus')),
    regularPurchasePriceNett: builder.opt(builder.bigNum('regularPurchasePriceNett')),
    promoPurchaseStartDate: builder.opt(builder.date('promoPurchaseStartDate', DateParser_1.DateParser.ISO_PATTERN)),
    promoPurchaseEndDate: builder.opt(builder.date('promoPurchaseEndDate', DateParser_1.DateParser.ISO_PATTERN)),
    purchaseForecastSMPA: builder.opt(builder.bigNum('purchaseForecastSMPA')),
    confirmedPurchaseForecastSMPA: builder.opt(builder.bigNum('confirmedPurchaseForecastSMPA')),
    obligatoryToBuy: builder.bool('obligatoryToBuy'),
    split: builder.bigNum('split', new BigNumberRangeValidator_1.BigNumberRangeValidator(SupplierAgreement.SPLIT_VALUE_MIN, SupplierAgreement.SPLIT_VALUE_MAX)),
    promoVolume: builder.bigNum('promoVolume'),
    minimalVolume: builder.opt(builder.bigNum('minimalVolume')),
    maximalVolume: builder.opt(builder.bigNum('maximalVolume')),
    unitBackDiscount: builder.opt(builder.bigNum('unitBackDiscount', new BigNumberGreaterThanValidator_1.BigNumberGreaterThanValidator(big_decimal_1.bigdecimal(0), true))),
    supplierInvoice: builder.opt(builder.str('supplierInvoice')),
    unitBackDiscountRealization: builder.opt(builder.senum('unitBackDiscountRealization', UnitBackDiscountRealizationEnum_1.UnitBackDiscountRealizationEnum, CodebookLookupSequence_1.CodebookLookupSequence.UnitBackDiscountRealization)),
    secondaryPlacementFee: builder.opt(builder.bigNum('secondaryPlacementFee')),
    leafletFee: builder.opt(builder.bigNum('leafletFee')),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag),
    warningFlags: builder.flags('warningFlags', SupplierAgreementWarningFlag_1.SupplierAgreementWarningFlag),
    costPriceFormat: builder.opt(builder.senum('costPriceFormat', CostPriceFormatEnum_1.CostPriceFormatEnum, CodebookLookupSequence_1.CodebookLookupSequence.CostPriceFormat)),
    processed: builder.bool('processed'),
    snapshotOriginId: builder.opt(builder.str('snapshotOriginId')),
    lastPromoPurchaseUpdate: builder.opt(builder.date('lastPromoPurchaseUpdate', DateParser_1.DateParser.ISO_PATTERN))
  };
}();